import { useEffect, useState } from 'react'
import Select from 'react-select'
import Swal from 'sweetalert2'

import { SelectOption, SelectData } from './models'
import { getCashBoxesLookup } from '../core/_requests'
import { SelectStyles } from '../../../components/Select'
import { useThemeMode } from '../../../_metronic/partials'
import { getGeneralError } from '../api/errors'

export const selectType = 'cashBox'

const CashBoxFilter = ({
  changeSelect,
  isMultiple,
  value,
}: {
  changeSelect: (selectData: SelectData) => void
  initialFilter?: Array<number>
  isMultiple?: boolean
  value: number[]
}) => {
  const { mode: theme } = useThemeMode()
  const [options, setOptions] = useState<Array<SelectOption>>([])
  const [loading, setLoading] = useState(true)

  const updateListCashBoxes = async () => {
    try {
      const response = await getCashBoxesLookup()
      if (!response?.data?.success) {
        throw new Error(
          'errors' in response.data ? response.data?.errors?.general_error : 'Unknown error'
        )
      }
      setOptions(response.data.data)
    } catch (error: unknown) {
      console.error('Ошибка загрузки касс: ', error)
      const message =
        getGeneralError(error) ?? (error instanceof Error ? error.message : undefined) ?? 'Не удалось загрузить кассы'
      Swal.fire({ title: 'Ошибка загрузки касс', text: message, icon: 'error' })
      setOptions([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    updateListCashBoxes()
  }, [])

  const handleChange = (selectedData: any) => {
    const values = !selectedData
      ? []
      : !isMultiple
      ? [selectedData.value]
      : selectedData.map((item: SelectOption) => item.value)

    changeSelect({
      value: values,
      type: selectType,
    })
  }

  return loading ? (
    <>Загрузка касс...</>
  ) : (
    <Select
      value={options.filter((o: SelectOption) => value?.find((sv) => sv === o.value)) || ''}
      onChange={handleChange}
      isClearable={options.some((v) => !v.isFixed)}
      isMulti={isMultiple}
      options={options}
      placeholder={'Выберите кассу'}
      styles={SelectStyles(theme)}
    />
  )
}

export default CashBoxFilter
